let apirl = ''
if (process.env.NODE_ENV === 'production') {
    // apirl = 'http://localhost:8080'
    apirl = 'https://console-api.irmastore.id'
} else {
    // apirl = 'http://localhost:8080'
    apirl = 'https://console-api.irmastore.id'
}

export const apiurl = apirl;
